import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { ClpConnectionState } from '@cbridge-packages/api-clp';
import {
  IClientSymbolQuote, ILpSymbolKey, ILpSymbolQuote, IQuoteClientSymbolRow, IQuoteLpSymbolRow,
} from './symbolQuotes.interface';

export interface ILoadServerSymbolsParams {
  serverId: string;
  symbolGroup?: string;
  search?: string;
  limit?: number;
  skip?: number;
}

export interface ILoadLpSymbolsParams {
  lpId: number;
  symbolGroup?: string;
  search?: string;
  limit?: number;
  skip?: number;
}

export namespace SymbolQuotesAction {
  const actionCreator = actionCreatorFactory('SymbolQuotes');

  /** Loads the paginated client-symbol rows for a server (REST), filtered by symbol group/search. */
  export const loadServerSymbols = actionCreator.async<
    ILoadServerSymbolsParams,
    { items: IQuoteClientSymbolRow[]; total: number },
    IApiErrorParams
  >('LOAD_SERVER_SYMBOLS');

  /** Loads the paginated LP-symbol rows for an LP (REST), filtered by symbol group/search. */
  export const loadLpSymbols = actionCreator.async<
    ILoadLpSymbolsParams,
    { items: IQuoteLpSymbolRow[]; total: number },
    IApiErrorParams
  >('LOAD_LP_SYMBOLS');

  export const clearSymbols = actionCreator('CLEAR_SYMBOLS');

  /** Open the CLP WS session. `clientId` is required on the server route, omitted on the LP route. */
  export const connect = actionCreator<{ clientId?: string }>('CONNECT');
  export const connectFailed = actionCreator<{ error: string }>('CONNECT_FAILED');
  export const disconnect = actionCreator('DISCONNECT');
  export const connectionStateChanged = actionCreator<{ state: ClpConnectionState }>('CONNECTION_STATE_CHANGED');

  /** The set of client symbols currently visible in the grid viewport (drives subscription diff). */
  export const setVisibleClientSymbols = actionCreator<{ symbols: string[]; marketDepth: number }>('SET_VISIBLE_CLIENT_SYMBOLS');
  export const setVisibleLpSymbols = actionCreator<{ items: ILpSymbolKey[]; marketDepth: number }>('SET_VISIBLE_LP_SYMBOLS');

  export const ingestClientQuotes = actionCreator<{ quotes: IClientSymbolQuote[] }>('INGEST_CLIENT_QUOTES');
  export const ingestLpQuotes = actionCreator<{ quotes: ILpSymbolQuote[] }>('INGEST_LP_QUOTES');

  export const failed = actionCreator<{ error: string }>('FAILED');
}
